/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import injectJss from 'react-jss';
import HeadingForm from '../../layout/HeadingForm';
import { mapClaimData, moduleNames } from '../../services';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import ErgoNavButton from '../../components/ErgoNavButton';
import { legalConsentProps } from '../../models/panels';
import { getHeadingData } from '../../helpers/formData/propertyFormData';
import {
  ContactDetails,
  IncidentDetails,
  PayingOutDetails,
  PoliceDetails,
  StolenDamagedObjectsDetails,
  DamageOfAccidentDetails,
  YourMessageDetails,
  FileDetails,
} from './sections';
import { extractTemplateData } from '../../helpers/pdfHelpers';
import styles from './PropertySummaryPage.jss';

class PropertySummaryPage extends React.PureComponent {
  state = {
    mappedFormData: {},
  };

  componentDidMount() {
    const { formData } = this.props;
    this.setState({ mappedFormData: mapClaimData(formData, moduleNames.PROPERTY).data },
      () => extractTemplateData('summaryPageWrapper'));
  }

  render() {
    const {
      isValid, localePath, classes, onClick,
    } = this.props;
    const { mappedFormData } = this.state;
    const { t } = this.context;

    const defaultProps = {
      formData: mappedFormData,
      localePath,
      className: classes.detailsWrapper,
    };

    return (
      <ContentWrapper>
        <HeadingForm
          value={t(`${localePath}.heading`, {
            fullName: getHeadingData(mappedFormData),
          })}
          commentValue={t(`${localePath}.comment`)}
        />
        <div id="summaryPageWrapper">
          <ContactDetails {...defaultProps} />
          <IncidentDetails {...defaultProps} />
          <PoliceDetails {...defaultProps} />
          <DamageOfAccidentDetails {...defaultProps} />
          <StolenDamagedObjectsDetails {...defaultProps} />
          <PayingOutDetails {...defaultProps} />
          <YourMessageDetails {...defaultProps} />
          <FileDetails {...defaultProps} />
        </div>

        <div className="esc_grid">
          <div className={`esc_grid__wrapper ${classes.gridWrapper}`}>
            <div className="esc_col esc_col-12 esc_col-s-3 esc_col-m-2">
              <ErgoNavButton previous onClick={onClick} shouldNavigateAfterClick type="submit" />
            </div>
            <div className="esc_col esc_col-12 esc_col-s-8 esc_col-m-4">
              <ErgoNavButton
                title={`${localePath}.ok`}
                onClick={onClick}
                disabled={!isValid}
                shouldNavigateAfterClick
                type="submit"
              />
            </div>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ formData }) => ({ formData });

PropertySummaryPage.propTypes = legalConsentProps.props;
PropertySummaryPage.defaultProps = legalConsentProps.defaultProps;
PropertySummaryPage.contextTypes = {
  t: PropTypes.func,
};

export { PropertySummaryPage as PropertySummaryPagePlain };
export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  injectJss(styles),
)(PropertySummaryPage);
